"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceGenerationControlling = class UcInvoiceGenerationControlling extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_selectedInvoiceGroups = new core_1.ComponentValueCache(this, "selectedInvoiceGroups", "UcInvoiceGenerationControlling.selectedInvoiceGroups");
    }
    getAllRows(...args) {
        return this.values.rows;
    }
    getInvoiceGroups(...args) {
        const [rows] = args;
        const visited = [];
        const result = [];
        for (let row of rows) {
            const value = row.invoice_group_id;
            if (visited.indexOf(value) > -1) {
                continue;
            }
            result.push({ value, text: value ? value.toUpperCase() : "BLANK" });
            visited.push(value);
        }
        return result;
    }
    createGroups(...args) {
        const [rows] = args;
        return _
            .chain(rows)
            .groupBy(p => `${p.partner_id}${p.rental_id}`)
            .map((rows, group) => {
            const visibleRows = _.filter(rows, this.isRowVisible);
            if (!visibleRows.length) {
                return;
            }
            return {
                ...visibleRows[0],
                rows: visibleRows,
                totals: this.calculateTotals(visibleRows)
            };
        })
            .filter(p => !!p)
            .value();
    }
    calculateTotals(...args) {
        const [rows] = args;
        const totals = {};
        for (let row of rows) {
            for (let colName of this.values.columns) {
                if (!row[colName] || row[colName].net == null) {
                    continue;
                }
                const net = row[colName].net;
                if (totals[colName] == null) {
                    totals[colName] = net;
                    continue;
                }
                totals[colName] += net;
            }
        }
        return totals;
    }
    applyFilters(...args) {
        this.groups = this.createGroups(this.getAllRows());
        this.pager.setItems(this.groups);
    }
    isRowVisible(...args) {
        const [row] = args;
        const selectedInvoiceGroups = this.selectedInvoiceGroups;
        return selectedInvoiceGroups.length === 0
            || selectedInvoiceGroups.includes(row.invoice_group_id);
    }
    scrollItems(...args) {
        const pager = this.pager;
        const [m, n] = pager.history.slice(-2);
        const $el = this.$refs.items;
        if (m < n) {
            $el.scrollTop = 0;
        }
        else {
            $el.scrollTop = $el.scrollHeight;
        }
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    pageSize;
    rowHeaderColumnWidth;
    dataColumnWidth;
    resizeTrigger;
    selectedInvoiceGroups;
    selectedItems;
    ts;
    values;
    async $$load_values() {
        return this.$fn.fetch('view_draft_invoice_lines');
    }
    invoiceGroups;
    async $$load_invoiceGroups() {
        return this.getInvoiceGroups(this.getAllRows());
    }
    groups;
    async $$load_groups() {
        return this.createGroups(this.getAllRows());
    }
    filterInputValue;
    pager;
    async $$load_pager() {
        return this.$fn.pager(this.groups, this.$data.pageSize);
    }
    laggingApplyFilters;
    async $$load_laggingApplyFilters() {
        return _.debounce(_.throttle(this.applyFilters, 300), 500);
    }
    ux;
    b_7315092382398562_style;
    b_4440454779651433_style;
    async $$load_b_4440454779651433_style() {
        return {
            width: this.dataColumnWidth,
        };
    }
    b_5218831530088670_style;
    async $$load_b_5218831530088670_style() {
        return {
            width: this.rowHeaderColumnWidth,
        };
    }
    b_5119818220584553_style;
    async $$load_b_5119818220584553_style() {
        return {
            width: this.dataColumnWidth,
        };
    }
    dataMembers = ['pageSize', 'rowHeaderColumnWidth', 'dataColumnWidth', 'resizeTrigger', 'selectedInvoiceGroups', 'selectedItems', 'ts', 'values', 'invoiceGroups', 'groups', 'filterInputValue', 'pager', 'laggingApplyFilters', 'ux', 'b_7315092382398562_style', 'b_4440454779651433_style', 'b_5218831530088670_style', 'b_5119818220584553_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                pageSize: 10,
                rowHeaderColumnWidth: "auto",
                dataColumnWidth: "200px",
                resizeTrigger: 0,
                selectedInvoiceGroups: [],
                selectedItems: [],
                ts: null,
                values: null,
                invoiceGroups: null,
                groups: null,
                filterInputValue: null,
                pager: null,
                laggingApplyFilters: null,
                ux: null,
                b_7315092382398562_style: {
                    "max-width": "1280px",
                },
                b_4440454779651433_style: null,
                b_5218831530088670_style: null,
                b_5119818220584553_style: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async evh_4615685607825208_clickPreventStop(event, scope) {
        return await this.actions.evh_4615685607825208_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4592790460410433_script_7422_getActionArgs_value($event) {
        this.laggingApplyFilters();
    }
    async act_4592790460410433_script_7422_getActionArgs($event) {
        return {
            value: () => this.act_4592790460410433_script_7422_getActionArgs_value($event),
        };
    }
    async evh_4592790460410433_change(event, scope) {
        return await this.actions.evh_4592790460410433_change.executeFromDOM(this, event, scope);
    }
    async act_3723353993403825_showModal_7424_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.scope.invoice.invoice_id,
            },
        };
    }
    async evh_3723353993403825_clickPerventStop(event, scope) {
        return await this.actions.evh_3723353993403825_clickPerventStop.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_script_7426_getActionArgs_value($event) {
        (this.pager.setCurrentPage($event.originalEvent),
            this.scrollItems(this.pager));
    }
    async act_1548630417156826_script_7426_getActionArgs($event) {
        return {
            value: () => this.act_1548630417156826_script_7426_getActionArgs_value($event),
        };
    }
    async evh_1548630417156826_change(event, scope) {
        return await this.actions.evh_1548630417156826_change.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_4615685607825208_reloadComponentData_7420 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_4615685607825208_clickPreventStop_7419 = new core_1.actions.EventHandlerImpl({
            action: act_4615685607825208_reloadComponentData_7420,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_4615685607825208_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4615685607825208_clickPreventStop_7419],
        });
        const act_4592790460410433_script_7422 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4592790460410433_script_7422_getActionArgs,
            events: [],
        });
        const evh_4592790460410433_change_7421 = new core_1.actions.EventHandlerImpl({
            action: act_4592790460410433_script_7422,
            event: "change",
            displayName: "script",
        });
        const evh_4592790460410433_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4592790460410433_change_7421],
        });
        const act_3723353993403825_showModal_7424 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3723353993403825_showModal_7424_getActionArgs,
            events: [],
        });
        const evh_3723353993403825_clickPerventStop_7423 = new core_1.actions.EventHandlerImpl({
            action: act_3723353993403825_showModal_7424,
            event: "click.pervent.stop",
            displayName: "showModal",
        });
        const evh_3723353993403825_clickPerventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3723353993403825_clickPerventStop_7423],
        });
        const act_1548630417156826_script_7426 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1548630417156826_script_7426_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_change_7425 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_script_7426,
            event: "change",
            displayName: "script",
        });
        const evh_1548630417156826_change = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_change_7425],
        });
        return {
            act_4615685607825208_reloadComponentData_7420,
            evh_4615685607825208_clickPreventStop_7419,
            evh_4615685607825208_clickPreventStop,
            act_4592790460410433_script_7422,
            evh_4592790460410433_change_7421,
            evh_4592790460410433_change,
            act_3723353993403825_showModal_7424,
            evh_3723353993403825_clickPerventStop_7423,
            evh_3723353993403825_clickPerventStop,
            act_1548630417156826_script_7426,
            evh_1548630417156826_change_7425,
            evh_1548630417156826_change,
            reload: act_4615685607825208_reloadComponentData_7420,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UcInvoiceGenerationControlling.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceGenerationControlling.prototype, "onSize", null);
UcInvoiceGenerationControlling = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceGenerationControlling);
exports.default = UcInvoiceGenerationControlling;
vue_property_decorator_1.Vue.component("UcInvoiceGenerationControlling", UcInvoiceGenerationControlling);
